import React from 'react'
import Draggable from "../../../DnD/Draggable";
import InputWrapper from "../../../../../components/Input/InputWrapper";

function Radio() {
    return (
        <Draggable id="input-radio">
            <InputWrapper>
                Radio select
                <div>
                    <label>
                        <input type="radio" className="radio" checked readOnly/>
                        <span className="checkmark"></span>
                    </label>
                </div>
            </InputWrapper>
        </Draggable>
    )
}

export default Radio
